export const consentInfo = [
    {
        title: 'Task Details',
        body: 'This experiment is to identify voice patterns in an educational setting. We  want to find what makes someone’s voice engaging. In this experiment, you will be reading some text in your best teacher voice. You’ll have to answer a few questions so we can use it to process the voice. Once the voice is processed, we will be comparing it with well-known educators (Bill Nye, Hank Green and more).',
    },
    {
        title: 'Voluntary Participation and Right to Withdraw',
        body: 'Your participation is entirely voluntary.  You may end your participation at any point without penalty by exiting and not clicking “submit” after recording. However, once you have submitted your data it will not be possible to withdraw from the study as the data is stored without collection of your name or contact information.',
    },
    {
        title: 'Procedures',
        body: 'We have created a game to help us collect vocal data of engaging teachers. You will be asked a series of questions to help us better analyze your voice. Next you will listen to some audio clips of teachers and tell us which you find most engaging. Then it is your turn! After approving access to your microphone, you will be prompted with a scenario and a script and will have a chance to record your very best teaching voice.',
    },
    {
        title: 'Data Retention',
        body: 'Data provided will be stored in a database for the use of future researchers. The data will be stored on Amazon Web Services (AWS) servers within Canada for up to 48 hours. For long term storage the data will be stored on a Compute Canada server as well as in the Federated Research Data Repository (FRDR) where researcher will be able to apply to access the data for research purposes. For updates on publications and research using this data check this website for updates.',
    },
    {
        title: 'Risks/Discomforts',
        body: 'We do not think there is anything in this study that could harm you, and there are no foreseeable risks to you in participating.',
    },
    {
        title: 'Benefits',
        body: 'Although it may not directly benefit you, this study may benefit society by improving virtual teaching agents, helping to reduce burden on overworked teachers.',
    },
    {
        title: 'Compensation',
        body: 'There is no compensation for completing this experiment.',
    },
    {
        title: 'Confidentiality',
        body: 'In this study, we will collect your age range, English proficiency, and public speaking experience. You can optionally provide several other pieces of information including gender and country of origin.  No directly identifying data will be stored along with your responses. We note that your voice will be used, and this could potentially be identifiable.',
    },
    {
        title: 'Inclusion and Exclusion Criteria',
        body: 'Exclusion criteria is anyone under the age of 18 years old. There is also a preference for those who are proficient in English so that you are able to understand the prompts and that participants are in an environment with minimal noise so that the voice data will be clear.',
    },
    {
        title: 'Contact Information',
        body: 'If you have any questions about this study, you may contact the researchers citizenscience@rosielab.ca.',
    },
    {
        title: 'Concerns or Complaints',
        body: 'If you have any concerns about your rights as a research participant and/or your experiences while participating in this study, you may contact the SFU Office of Research Ethics at dore@sfu.ca or 778-782-6618.',
    },
];
